export default __webpack_public_path__ + "static/media/arrowLeft.877079ab.svg";